<template>
  <div class="section-wrapper">
    <div class="row">
      <volcan-input-text v-model="getItemRes.name" text="Nom" class="col-12" />
    </div>
    <div class="row">
      <volcan-input-datepicker
        v-model="projectLocal.dateTime"
        text="Date"
        type="date"
        class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12"
      />
      <volcan-input-checkbox
        v-model="projectLocal.isOngoing"
        text="Projet en cours"
        class="col-6"
      />
    </div>
    <div class="row">
      <volcan-input-redactor
        v-model="getItemRes.details"
        text="Description"
        class="col-12"
      />
    </div>
    <div class="row">
      <volcan-dropzone
        v-model="projectLocal.images"
        :moduleName="moduleName"
        :options="{
          thumbnailHeight: 150,
          thumbnailWidth: 150,
          dictDefaultMessage: 'Déposer un fichier (cliquer glisser)',
          acceptedFiles: 'image/*',
        }"
        text="Images du projet"
        class="col-12"
      />
    </div>
  </div>
</template>
<script>
import helpers from "@mixins/helpers.js";
export default {
  name: "volcan-project",
  mixins: [helpers],
  data() {
    return {
      tabs: {
        languageIdActive: 0,
        content: {
          content: {
            title: "Contenu",
            active: true,
            hasLanguage: true,
          },
          seo: {
            title: "Seo",
            active: false,
            hasLanguage: true,
          },
        },
      },
    };
  },
  props: {
    project: { type: Object },
    languageIdActive: { type: Number },
    moduleName: { type: String },
  },
  model: {
    prop: "project",
    event: "project:change",
  },
  watch: {
    languageIdActive: function (val) {
      this.tabs.languageIdActive = val;
    },
  },
  computed: {
    projectLocal: {
      get() {
        return this.project;
      },
      set(value) {
        this.$emit("project:change", value);
      },
    },
    getItemRes() {
      return this.getResWithLangId(this.projectLocal, this.languageIdActive);
    },
  },
  methods: {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// components/Custom/project/projet.vue